export default __webpack_public_path__ + "static/media/overcome-corporate-challenges.9adf078f.svg";